import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ECCOnboardingSchema } from '../pages/OnBoardingPage/ECC/schema'

type OnboardingState = Partial<ECCOnboardingSchema>

const initialState: OnboardingState = {}

const eccOnboardingSlice = createSlice({
    name: 'eccOnboarding',
    initialState,
    reducers: {
        setECCFormData: (
            state,
            action: PayloadAction<Partial<ECCOnboardingSchema>>
        ) => {
            Object.assign(state, action.payload)
        },
        resetEccOnboarding: () => initialState,
    },
})

export const { setECCFormData, resetEccOnboarding } = eccOnboardingSlice.actions
export default eccOnboardingSlice.reducer
